var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkmark-a",
    d: "M7.25269842,33.2086244 L7.25269842,33.2086244 C8.79968309,31.139936 11.7307652,30.7170117 13.7994536,32.2639963 C13.9758883,32.3959359 14.1427805,32.5401766 14.2988833,32.6956411 L29.2722338,47.6077543 L57.1900353,8.91834707 C58.6841829,6.84770824 61.5740132,6.38036974 63.6446521,7.87451731 C63.8009903,7.98732906 63.9501193,8.10980903 64.0911656,8.24123988 L64.0911656,8.24123988 C66.2871831,10.2875493 66.6320903,13.642246 64.8983875,16.0925826 L31.9438937,62.6689641 C31.3059119,63.5706586 30.0577576,63.7844399 29.1560631,63.1464581 C29.0579244,63.0770214 28.9662462,62.9988775 28.8821421,62.9129755 L7.79547562,41.3755491 C5.62571417,39.1594056 5.39529652,35.6924148 7.25269842,33.2086244 Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark.911a40be7a8ff85adb794e34456432bb.svg";